// extracted by mini-css-extract-plugin
module.exports = {"root":"DallasList_root__Lcdkf","listItem":"DallasList_listItem__m0lGi","clickable":"DallasList_clickable__uZp91"};